import { render, staticRenderFns } from "./Consulting.vue?vue&type=template&id=63c29e78&scoped=true&"
import script from "./Consulting.vue?vue&type=script&lang=js&"
export * from "./Consulting.vue?vue&type=script&lang=js&"
import style0 from "./Consulting.vue?vue&type=style&index=0&id=63c29e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c29e78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
